import React, { Component } from 'react';
import { OrderedMap } from 'immutable';
import Address from './Address';

import css from './address.css';

import FlatButton from 'material-ui/FlatButton';
import { Card, CardActions } from 'material-ui/Card';
import ContentAddBox from 'material-ui/svg-icons/content/add-box';

class Addresses extends Component {

  constructor(props) {
    super(props);
    this.state = { addresses: OrderedMap({ [0]: {} }) };
  }

  handleUpdateForm = (key, attributes) => {
    this.setState({ addresses: this.state.addresses.merge({ [key]: attributes }) });
    this.props.updateForm(this.state.addresses.toList());
  };

  addAnotherAddress = () => {
    this.setState({ addresses: this.state.addresses.merge({ [this.state.addresses.size]: {} }) });
  };

  removeAddress = (key) => {
    this.setState({ addresses: this.state.addresses.delete(key) });
  };

  render() {
    return (
      <div>
        <h3 className={css.title} key='addresses-title'>
          Addresses
          <FlatButton primary={true} onClick={this.addAnotherAddress}>
            Add
          </FlatButton>
        </h3>
        {this.state.addresses.mapEntries(([key, value]) =>
          [
            key,
            <Card key={key}>
              <Address
                updateForm={this.handleUpdateForm.bind(this, key)}
                className={this.props.fieldClass}
                fullWidth={this.props.fullWidth}
              />
                <CardActions
                  style={{ textAlign: 'right' }}
                >
                  <FlatButton onClick={this.removeAddress.bind(this, key)}>
                    Remove
                  </FlatButton>
                </CardActions>
            </Card>,
          ]
        ).toList()}
      </div>
    );
  }

}

export default Addresses;



/** WEBPACK FOOTER **
 ** ./components/forms/Addresses.js
 **/